import { render, staticRenderFns } from "./im-audio-message.vue?vue&type=template&id=63c02022&scoped=true"
import script from "./im-audio-message.vue?vue&type=script&lang=js"
export * from "./im-audio-message.vue?vue&type=script&lang=js"
import style0 from "./im-audio-message.vue?vue&type=style&index=0&id=63c02022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c02022",
  null
  
)

export default component.exports